'use client'

import dynamic from 'next/dynamic'

const LeafletMap = dynamic(() => import('./LeafletMap'), {
  ssr: false,
})

export const MapEmbed: React.FC<{ latitude: number; longitude: number }> = ({
  latitude,
  longitude,
}) => {
  return (
    <div className="map-block">
      <LeafletMap latitude={String(latitude)} longitude={String(longitude)} />
    </div>
  )
}
